import cn from 'classnames';
import * as React from 'react';

import FontAwesome from 'components/FontAwesome';
import ToggleButton, { ToggleButtonProps } from './ToggleButton';
import { block } from './utils';

type Props = ToggleButtonProps;

const AlignRightToggle: React.SFC<Props> = ({ className, ...buttonProps }) => (
  <ToggleButton
    className={cn(block('alignright-toggle'), className)}
    {...buttonProps}
  >
    <FontAwesome icon="align-right" />
  </ToggleButton>
);

export default AlignRightToggle;
export { Props as BoldToggleProps };
